import { Guid } from '../../model/guid';
import {WidgetDataResponse} from './widgetDataRepository';

export class WidgetPrefetchedDataStore {
  _store: Map<Guid, WidgetDataResponse>;
  constructor() {
    this._store = new Map<Guid, WidgetDataResponse>();
  }

  populateStore = (widgetId: Guid, response: WidgetDataResponse) => {
    this._store.set(widgetId, response);
  };

  private _invalidateEntry = (widgetId: Guid) => {
    this._store.delete(widgetId);
  };

  tryGetDataForWidget = async (
    widgetId: Guid,
    fetchMethod: () => Promise<WidgetDataResponse>
  ): Promise<WidgetDataResponse> => {
    if (this._store.has(widgetId)) {
      const cachedValue = this._store.get(widgetId);
      if (cachedValue) {
        this._invalidateEntry(widgetId);
        return Promise.resolve(cachedValue);
      }
    }
    return await fetchMethod();
  };
}
